export default "__VITE_ASSET__i$Cl_4YI__"